
import React, { useState, useEffect } from "react";
import "../../assets/css/Toast.css";

// Toast types with their corresponding icons and colors
const TOAST_TYPES = {
  success: {
    icon: <i className="fa-solid fa-check text-white"></i>,
    bgColor: "#4CAF50",
    iconBgColor: "#4CAF50",
  },
  info: {
    icon: <i className="fa-solid fa-info text-white"></i>,
    bgColor: "#2196F3",
    iconBgColor: "#2196F3",
  },
  warning: {
    icon: <i className="fa-solid fa-exclamation text-white"></i>,
    bgColor: "#FF9800",
    iconBgColor: "#FF9800",
  },
  error: {
    icon: <i className="fa-solid fa-exclamation text-white"></i>,
    bgColor: "#F44336",
    iconBgColor: "#F44336",
  },
};

// Toast positions with their corresponding animation classes
const POSITIONS = {
  topRight: "top-0 end-0 slide-from-right",
  topLeft: "top-0 start-0 slide-from-left",
  topCenter: "top-0 start-50 translate-middle-x slide-from-top",
  bottomRight: "bottom-0 end-0 slide-from-right",
  bottomLeft: "bottom-0 start-0 slide-from-left",
  bottomCenter: "bottom-0 start-50 translate-middle-x slide-from-bottom",
};

const Toast = ({
  message,
  type = "info",
  duration = 3000,
  position = "topRight",
  onClose,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) {
        setTimeout(onClose, 500); // Give more time for fade-out animation
      }
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const toastStyle = TOAST_TYPES[type] || TOAST_TYPES.info;
  const positionClass = POSITIONS[position] || POSITIONS.topRight;

  return (
    <div
      className={`position-fixed ${positionClass} m-3 toast-container`}
      style={{ zIndex: 1050 }}
    >
      <div
        className={`d-flex align-items-center rounded-pill shadow-sm px-3 py-2 mt-5 ${
          visible ? "show-toast" : "hide-toast"
        }`}
        style={{
          backgroundColor: "white",
          minWidth: "250px",
          border: `1px solid ${toastStyle.bgColor}`,
          transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
        }}
      >
        <div
          className="rounded-circle d-flex justify-content-center align-items-center me-3 pulse-effect"
          style={{
            backgroundColor: toastStyle.iconBgColor,
            width: "30px",
            height: "30px",
            flexShrink: 0,
          }}
        >
          {toastStyle.icon}
        </div>
        <div className="flex-grow-1">
          <span>{message}</span>
        </div>
        <button
          type="button"
          className="btn-close ms-3"
          aria-label="Close"
          onClick={() => {
            setVisible(false);
            setTimeout(() => {
              if (onClose) onClose();
            }, 500);
          }}
        ></button>
      </div>
    </div>
  );
};

export default Toast;
